import { Component, OnInit, OnDestroy, AfterViewInit } from "@angular/core";
import { Router } from "@angular/router";
import { JsLoaderService } from "src/shared/services/js-loader.service";
import { AppConfig } from "../../app-config";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html"
})
export class HomeComponent implements OnInit {
  constructor(private jsLoader: JsLoaderService, private config: AppConfig) { }

  IsPortal = this.config.IsPortal;

  ngOnInit() {
    this.jsLoader.loadScripts();
    console.log(this.IsPortal);
  }
}
